import React from 'react';
import { useIntl } from 'react-intl-next';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { blockTypeMessages } from '@atlaskit/editor-common/messages';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { TextSelection } from '@atlaskit/editor-prosemirror/state';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
import TextHeadingFiveIcon from '@atlaskit/icon-lab/core/text-heading-five';
import TextHeadingFourIcon from '@atlaskit/icon-lab/core/text-heading-four';
import TextHeadingOneIcon from '@atlaskit/icon-lab/core/text-heading-one';
import TextHeadingSixIcon from '@atlaskit/icon-lab/core/text-heading-six';
import TextHeadingThreeIcon from '@atlaskit/icon-lab/core/text-heading-three';
import TextHeadingTwoIcon from '@atlaskit/icon-lab/core/text-heading-two';
import { HEADING_2, HEADING_5, HEADING_1, HEADING_3, HEADING_4, HEADING_6 } from './consts';
var headingIcons = [TextHeadingOneIcon, TextHeadingTwoIcon, TextHeadingThreeIcon, TextHeadingFourIcon, TextHeadingFiveIcon, TextHeadingSixIcon];
var headingMessages = [blockTypeMessages.heading1, blockTypeMessages.heading2, blockTypeMessages.heading3, blockTypeMessages.heading4, blockTypeMessages.heading5, blockTypeMessages.heading6];
var HeadingBlockTypes = [HEADING_1, HEADING_2, HEADING_3, HEADING_4, HEADING_5, HEADING_6];
var HeadingBlockMenuItem = function HeadingBlockMenuItem(_ref) {
  var level = _ref.level,
    api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var Icon = headingIcons[level - 1];
  var message = headingMessages[level - 1];
  var currentBlockType = useSharedPluginStateSelector(api, 'blockType.currentBlockType');
  var selection = useSharedPluginStateSelector(api, 'selection.selection');
  var isTextSelection = selection instanceof TextSelection;
  var isHeading = isTextSelection && currentBlockType && HeadingBlockTypes.includes(currentBlockType);
  var currentHeadingLevel = isHeading ? currentBlockType.level : undefined;
  var isSelected = isHeading && currentHeadingLevel === level;
  var handleClick = function handleClick(event) {
    if (!selection) {
      return;
    }
    if (!isSelected) {
      var _api$blockMenu;
      var triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? INPUT_METHOD.KEYBOARD : INPUT_METHOD.MOUSE;
      var inputMethod = INPUT_METHOD.BLOCK_MENU;
      api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.formatNode("heading".concat(level), {
        inputMethod: inputMethod,
        triggeredFrom: triggeredFrom
      }));
    }
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    onClick: handleClick,
    isSelected: isSelected,
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      label: ""
    })
  }, formatMessage(message));
};
export var createHeadingBlockMenuItem = function createHeadingBlockMenuItem(_ref2) {
  var level = _ref2.level,
    api = _ref2.api;
  return function () {
    return /*#__PURE__*/React.createElement(HeadingBlockMenuItem, {
      level: level,
      api: api
    });
  };
};